import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const proofpointProtectionServer = defineConnector({
  identifier: "proofpointProtectionServer",
  name: "Proofpoint Protection Server",
  tagLine: "Email security gateway",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ server }) => domainToRegex(server),
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Get your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "You'll need admin credentials for your Proofpoint Protection Server (PPS) appliance. The API is exposed on port 10000 by default.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Server",
          required: true,
          placeholder: "pps.example.com:10000",
          helperText:
            "Your Proofpoint Protection Server hostname and port (e.g. pps.example.com:10000).",
          target: { kind: "configuration", field: "server" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.server}/pss/api/v1/configuration`,
  },
  publicEnvVars: ({ server }) => ({
    PROOFPOINT_PROTECTION_SERVER_URL: server ? `https://${server}` : "",
  }),
});
